<template>
  <div class="page">
    <!-- <div class="searchBar">
      <yd-search v-model="params.queryKey" :on-submit="submitHandler" :on-cancel="cancelHandle" placeholder="搜索线路"></yd-search>
    </div> -->
    <div class="topLayout">
      <div class="calendarLayout">
        <!-- <yd-cell-item arrow style="float:left; width:50%;">
          <span slot="left">开始：</span>
          <yd-datetime slot="right" type="date" :start-date="startDate" v-model="selectedFromDate" :callback='selectedCertainDate'></yd-datetime>
        </yd-cell-item>
        <yd-cell-item arrow style="float:right; width:50%;">
          <span slot="left">截止：</span>
          <yd-datetime slot="right" type="date" :start-date="startDate" v-model="selectedToDate" :callback='selectedCertainDate'></yd-datetime>
        </yd-cell-item> -->
        <van-cell title="开始"  @click="showCal(1)">
        <!-- 使用 right-icon 插槽来自定义右侧图标 -->
        <template #right-icon>
          <div style="display:flex;align-items:center;justify-content:flex-end">
            
            <span class="value">{{startTime}}</span>
            <van-icon name="arrow" style="line-height: inherit;" />
          </div>
          
        </template>
      </van-cell>
      <van-cell title="截止"  @click="showCal(2)">
        <!-- 使用 right-icon 插槽来自定义右侧图标 -->
        <template #right-icon>
          <div style="display:flex;align-items:center;justify-content:flex-end">
            
            <span class="value">{{endTime}}</span>
            <van-icon name="arrow" style="line-height: inherit;" />
          </div>
          
        </template>
      </van-cell>
      </div>
    </div>
    <div class="listContentLayout" id="listContentLayout" ref="box">
      <ul v-for="(item, index) in itemList" :key="index">
        <li>
          <div class="cellLayout" @click="scanActivityAnalysis(item)">
            <p> <span>活动名称：</span> <span class="item-detail" style="color:#333">{{item.shareTitle}}</span></p>
            <p> <span>浏览次数：</span> <span class="item-detail" style="color:#333">{{item.views}}次</span></p>
            <!-- <p> <span>下单时间：</span> <span class="item-detail" style="color:#333">{{moment(item.updateTime).format("YYYY-MM-DD")}}</span></p> -->
          </div>
        </li>
        <div class="barlineLayout"></div>
      </ul>
      <div v-if="itemList.length == 0" class="contentList">
        <van-empty description="啊哦～暂时没有数据呢～" />
      </div>
    </div>
    <calendar
      :show.sync="show1"
      @change="changeCal1"
      :defaultDate="startTime"
      >
    </calendar>
    <calendar
      :show.sync="show2"
      @change="changeCal2"
      :defaultDate="endTime"
      >
    </calendar>
  </div>
</template>

<script>
import appService from "@/services/request/appService"
import store from 'store'
import moment from 'moment'
export default {
  name: 'BigDataIndex',
  data(){
    return{
      moment:moment,
      mine:{},
      startDate:'',
      selectedFromDate:'',
      selectedToDate:'',
      firstLoadEnd: false,
      itemList:[],
      index:this.$route.query.index,
      show1:false,
      show2:false,
      startTime:"",
      endTime:'',
      params:{
        startTime:"",
        endTime:'',
        pageNumber:1
      }
    }
  },
  created() {
    this.getDefaultTime()
  },
  activated: function() {
    this.$refs.box.scrollTo(0, this.offsetY)
  },
  mounted:function(){
    this.$nextTick(function(){
      document.title = '线路分享明细'
      this.mine = store.get('mine')
      this.initCalendarDate()
      this.loadData(this.index)
    })
    window.addEventListener('scroll',this.scroll, true)
  },
  beforeDestroy: function() {
    window.removeEventListener('scroll', this.scroll,true)
  },
  methods:{
    submitHandler() {
      this.params.pageNumber = 1
      this.itemList =[]
      this.loadData(this.index,() => {
        this.$dialog.toast({
          mes: '未找到相关线路',
          timeout: 1500
        });
      })
    },
    cancelHandle() {
      this.params.queryKey = ''
      this.params.pageNumber = 1
      this.itemList =[]
      this.loadData(this.index)
    },
    scroll() {
      let scroll = document.getElementById('listContentLayout')
      // let _self = this
      // scroll.onscroll = function(){
        // console.log(this.newMessageFlag)
        //变量scrollTop是滚动条滚动时，距离顶部的距离
        var scrollTop = scroll.scrollTop;
        //变量windowHeight是可视区的高度
        var windowHeight =scroll.clientHeight;
        //变量scrollHeight是滚动条的总高度
        var scrollHeight = scroll.scrollHeight
          //滚动条到底部的条件
          if(scrollTop+windowHeight == scrollHeight){
            console.log(666)
            // this.params.pageNumber++
            this.loadData(this.index)
            //到了这个就可以进行业务逻辑加载后台数据了
            // console.log("到了底部");
            // _self.newMessageFlag = false
          }   
        // }
		},
    showCal(index){
      if(index == 1){
        this.show1 = true
      }
      if(index == 2){
        this.show2 = true
      }
      
    },
    changeCal1(date){
      // new Date(this.selectedDate)
      this.startTime = date.format('YYYY-MM-DD')
      this.params.startTime = new Date(date).getTime()
      console.log(date.format('YYYY-MM-DD'))
      this.show1 = false
      this.params.pageNumber = 1
      this.itemList =[]
      this.loadData(this.index)
      
    },
    changeCal2(date){
      // new Date(this.selectedDate)
      this.endTime = date.format('YYYY-MM-DD')
      this.params.endTime = new Date(date).getTime()
      console.log(date.format('YYYY-MM-DD'))
      this.show2 = false
      this.params.pageNumber = 1
      this.itemList = []
      this.loadData(this.index)
      
    },
    initCalendarDate() {
      var selectedFromDateTemp = new Date();
      selectedFromDateTemp.setDate(selectedFromDateTemp.getDate()-7)
      this.selectedFromDate = this.getDateFormatByDate(selectedFromDateTemp)
      var todayDate = new Date();
      this.selectedToDate = this.getDateFormatByDate(todayDate)
      var startDateTemp = new Date();
      var seperator = "-";
      var year = startDateTemp.getFullYear();
      var month = startDateTemp.getMonth() + 1;
      var day = startDateTemp.getDate();
      if (month >= 1 && month <= 9) {
        month = "0" + month;
      }
      if (day >= 0 && day <= 9) {
        day = "0" + day;
      }
      this.startDate = (year-1) + seperator + month + seperator + day
    },
    getDateFormatByDate(date) {
        var seperator = "-";
        var year = date.getFullYear();
        var month = date.getMonth() + 1;
        var day = date.getDate();
        if (month >= 1 && month <= 9) {
          month = "0" + month;
        }
        if (day >= 0 && day <= 9) {
          day = "0" + day;
        }
        return year + seperator + month + seperator + day
    },
    getDefaultTime(){
      const end = new Date();
      const start = new Date();
      start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
      this.params.startTime = start.getTime()
      this.params.endTime = end.getTime()
      this.startTime = this.moment(start.getTime()).format("YYYY-MM-DD")
      this.endTime =  this.moment(end.getTime()).format("YYYY-MM-DD")
      console.log(end,start)
   },
    loadData(index) {
      // var fromTimeStamp = this.changeDateToTimeStamp(this.selectedFromDate)
      // var toTimeStamp = this.changeDateToTimeStamp(this.selectedToDate)
      // appService
      //   .getOperationActivityListData({
      //     unionId: this.mine.unionId,
      //     startTime: fromTimeStamp,
      //     endTime: toTimeStamp,
      //     iid: this.mine.iid
      //   })
      //   .then(data => {
      //     this.firstLoadEnd = true
      //     this.itemList = data
      //   }, error => {
      //     this.firstLoadEnd = true
      //   })
      if(index == 5){
        appService
        .getOperationShareOrderListData({
          iid:this.$route.query.iid,
          unionId:store.get('loginData') ? store.get('loginData').id : this.mine.unionId,
          queryKey:this.params.queryKey,
          startTime:this.params.startTime,
          endTime:this.params.endTime,
          pageNumber:this.params.pageNumber,
          pageSize:10,
          saleIid:this.$route.query.saleIid?this.$route.query.saleIid:''
        })
        .then(data => {
          if(!!data && data.length>0){
            this.firstLoadEnd = true
            this.itemList = [...this.itemList,...data]
            this.params.pageNumber ++
          }else {
            if(typeof callback === 'function') callback()
          }
          
        }, error => {
          this.firstLoadEnd = true
        })
      }
    },
    changeDateToTimeStamp(dateStr) {
      var date = new Date(dateStr)
      var timeStamp = date.getTime()
      return timeStamp
    },
    // selectedCertainDate() {
    //   if(this.firstLoadEnd) {
    //     this.loadData(this.index)
    //   }
    // },
    scanActivityAnalysis(activityItem){
      this.$router.push({
        path: '/m/bigsharedata/detail',
        query:{
          id: activityItem.shareId,
          title:activityItem.shareTitle
        }
      })
    },
  },
  filters:{
    filterStatus(value){
      switch(value){
        case 1:
          return '已预订'
          break;
        case 2:
          return '已支付全款'
          break;
        case 3:
          return '取消订单'
          break;
        case 4:
          return '已退款'
          break;
        case 5:
          return '申请退款中'
          break;
        case -1:
          return '已失效'
          break;
      }
    }
  }
}
</script>

<style scoped lang="less">
.page{
  font-size: 0.24rem;
  .searchBar{
    position: absolute;
    width: 100%;
    top: 0;
    background-color: white;
    overflow: scroll;
    z-index: 99;
    & /deep/ .yd-search-input{
      padding: 5px 0px 5px 10px;
    }
  }
}
.topLayout{
  position: absolute;
  top: 0px;
  width: 100%;
  height: 1rem;
  padding: 0 10px;
  box-sizing: border-box;
}
.topLayout .calendarLayout{
  display:flex;
  width:100%;
  margin:0;
  padding:0;
  background-color:white;
  border-radius: 5px;
  box-sizing: border-box;
  overflow: hidden;
  & /deep/ .van-cell{
    .van-cell__title{
      width: 50px;
      flex-shrink: 0;
      flex: auto;
    }
    .van-cell__value{
      width: 100px;
      flex-shrink: 0;
      flex: auto;
    }
  }

}
.listContentLayout{
  position: absolute;
  top: 0;
  width: 100%;
  bottom: 0;
  margin-top: 50px;
  -webkit-overflow-scrolling: touch;
  overflow-y: scroll;
  padding:10px;
  box-sizing: border-box;
  padding-top: 0;
}
.cellLayout{
  padding: 12px;
  background-color: white;
  font-size: 0.28rem;
      border-radius: 5px;
  p{
    display: flex;
    justify-content: space-between;
    color: #666;
    span{
      width: 100px;
      flex-shrink: 0
    }
    .item-detail{
      flex: 1;
      text-align: right;
      overflow: hidden;
      text-overflow:ellipsis;
      white-space: nowrap;
    }
  }
}
.cellLayout .cellDetailLayout{
  display: flex;
  font-size: 0.24rem;
  color: #666;
  padding-top: 8px;
}
.cellLayout .cellDetailLayout p{
  width: calc(100% / 3);
}
.barlineLayout{
  height:10px;
  background-color: #f6f6f6;
  width: 100%;
}
</style>


<style lang="less">
  .m-calendar .m-months-container .m-months-wrapper .m-months .m-row:before{
    height: 0;
  }
  .m-calendar .m-toolbar .m-year-selector .m-prev-btn{
    background-image:url(./assets/img/prev.png);
    background-size: 12px;
    background-repeat: no-repeat;
    background-position: 0px;
  }
  .m-calendar .m-toolbar .m-year-selector .m-next-btn{
    background-image:url(./assets/img/next.png);
    background-size: 12px;
    background-repeat: no-repeat;
    background-position: 0px;
  }
  .m-calendar .m-toolbar .m-month-selector .m-prev-btn{
    background-image:url(./assets/img/prev.png);
    background-size: 12px;
    background-repeat: no-repeat;
    background-position: 0px;
  }
  .m-calendar .m-toolbar .m-month-selector .m-next-btn{
    background-image:url(./assets/img/next.png);
    background-size: 12px;
    background-repeat: no-repeat;
    background-position: 0px;
  }
</style>
